import * as React from 'react';
import LANGUAGES from '../Enums/Languages';

const LanguageContext: React.Context<string> = React.createContext(
  LANGUAGES.EN.toString()
);

export default LanguageContext;
